import { VcxBroker } from 'types/vcx';

export const iterableSubscriptionUrl = `https://links.iterable.com/lists/publicAddSubscriberForm?publicIdString=${import.meta.env.VITE_VCX_ITERABLE_ID}`;

export const vcxPublicListingBadge = 'Public listing';
export const vcxAssetClassTooltip =
	'The Innovation fund is now a publicly traded fund (VCX) and no longer actively part of your portfolio. You can still find historical investment information in your portfolio. Learn more about continuing to invest in this fund <a href="https://getvcx.com" target="_blank" rel="noopener noreferrer">here.</a>';

/* MIXPANEL EVENTS */
export const MXP_SIV_HERO = {
	'View Title': 'The public ticker for private tech',
	'View ID': 'vcx-hero'
};

export const MXP_SIV_DEMOCRATIZING = {
	'View Title': 'Democratizing venture capital',
	'View ID': 'vcx-democratizing'
};

export const MXP_SIV_ABOUT_VCX = {
	'View Title': 'About VCX',
	'View ID': 'vcx-about'
};

export const MXP_SIV_PORTFOLIO = {
	'View Title': 'Portfolio',
	'View ID': 'vcx-portfolio'
};

export const MXP_SIV_PERFORMANCE = {
	'View Title': 'Performance',
	'View ID': 'vcx-performance'
};

export const MXP_SIV_HYPOTHETICAL_GROWTH = {
	'View Title': 'Hypothetical growth of $10,000',
	'View ID': 'vcx-hypothetical-growth'
};

export const MXP_SIV_PODCAST = {
	'View Title': 'Insights',
	'View ID': 'vcx-podcast'
};

export const MXP_SIV_LITERATURE = {
	'View Title': 'Literature',
	'View ID': 'vcx-literature'
};

export const MXP_SIV_CTA = {
	'View Title': 'Sign up to receive updates about VCX',
	'View ID': 'vcx-cta'
};

export const MXP_SIV_FOOTER = {
	'View Title': 'Footer',
	'View ID': 'vcx-footer'
};

export const vcxBrokerages: Array<VcxBroker> = [
	{ name: 'Betterment', url: 'https://www.betterment.com/' },
	{ name: 'Charles Schwab', url: 'https://www.schwab.com/research/stocks/quotes/summary/VCX' },
	{ name: 'E*Trade', url: 'https://www.etrade.wallst.com/etrade-web/snapshot?symbol=vcx' },
	{ name: 'Fidelity', url: 'https://digital.fidelity.com/prgw/digital/research/quote/dashboard/summary?symbol=VCX' },
	{ name: 'Robinhood', url: 'https://robinhood.com/us/en/stocks/VCX' },
	{ name: 'SoFi', url: 'https://www.sofi.com/invest/' },
	{ name: 'Vanguard', url: 'https://investor.vanguard.com/' },
	{ name: 'Wealthfront', url: 'https://www.wealthfront.com/' }
];
